import React from 'react';
import useClassifiedDetails from '../../../hooks/useClassifiedDetails';
import ConversationPreviewCard from './ConversationPreviewCard';
/**
 * Interactive container to preview a conversation
 * and relevant details for it.
 * */
var ConversationPreview = function (props) {
    var conversation = props.conversation, currentUser = props.currentUser, isSelected = props.isSelected;
    // Load classified details and its book
    var book = useClassifiedDetails(conversation.classified).book;
    return React.createElement(ConversationPreviewCard, { conversation: conversation, currentUser: currentUser, isSelected: isSelected, book: book });
};
export default ConversationPreview;
